import { Controller } from "@hotwired/stimulus"
import React, { Suspense } from "react"
import { render, unmountComponentAtNode } from "react-dom"
import { BrowserRouter as Router } from "react-router-dom"
import { ErrorBoundary, Loading, ModalContainer } from "web/components"
import ObjectOverview from "web/components/ObjectOverview"
import { AppProviders, LibraryProviders } from "web/Providers"

export default class ObjectOverviewController extends Controller {
  static values = {
    subjectType: String,
    subjectId: Number,
    selectedOverviewId: Number,
    editPath: String,
    canEdit: Boolean,
  }

  initialize() {
    global.React = React
  }

  connect() {
    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <ErrorBoundary>
                <ObjectOverview
                  selectedOverviewId={this.selectedOverviewIdValue}
                  editPath={this.editPathValue}
                  subjectType={this.subjectTypeValue}
                  subjectId={this.subjectIdValue}
                  canEdit={this.canEditValue}
                />
              </ErrorBoundary>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }

  disconnect() {
    unmountComponentAtNode(this.element)
  }
}
